import {
  ButtonV3,
  type ButtonV3Props,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import { type ReactNode } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

export interface InStoreSizingOptionCtaProps
  extends Omit<ButtonV3Props, 'children'> {
  readonly label: MessageKey;
}

export interface InStoreSizingOptionProps {
  readonly content: ReactNode;
  readonly cta?: InStoreSizingOptionCtaProps;
  readonly name: MessageKey;
}

const InStoreSizingOptionCta = ({
  label,
  ...props
}: InStoreSizingOptionCtaProps): JSX.Element => {
  const t = useTranslations();

  return (
    <ButtonV3 {...props} variant="secondary-dark">
      {t.rich(label)}
    </ButtonV3>
  );
};

const InStoreSizingOption = ({
  content,
  cta,
  name,
}: InStoreSizingOptionProps): JSX.Element => {
  const t = useTranslations();

  return (
    <div className="mb-8 last:mb-0" data-cy="in-store-sizing-option">
      <TypographyV3
        className="m-0 font-bold uppercase leading-tighter tracking-wider"
        data-cy="in-store-sizing-option-name"
        Element="h3"
      >
        {t.rich(name)}
      </TypographyV3>
      <TypographyV3
        className="mt-3 text-lg last:mb-0"
        data-cy="in-store-sizing-option-content"
      >
        {content}
      </TypographyV3>
      {cta && <InStoreSizingOptionCta {...cta} />}
    </div>
  );
};

export default InStoreSizingOption;
